import React from "react";
import { COMPANY } from "./companyData";

const Row = ({ label, value }) => (
  <div className="rounded-xl bg-black/20 p-3">
    <div className="text-[10px] uppercase text-gray-400">
      {label}
    </div>

    <div className="flex justify-between gap-2 mt-1">
      <span className="text-white break-all">
        {value}
      </span>

      <button
        onClick={() => navigator.clipboard.writeText(value)}
        className="
          w-20 px-2 py-1
          text-[10px]
          rounded-lg
          bg-cyan-500/20
        "
      >
        📋
      </button>
    </div>
  </div>
);

export default function CompanyBankInfo() {
  return (
    <div
      className="
        rounded-3xl
        border border-cyan-500/30
        bg-cyan-950/20
        p-5
      "
    >
      <h2 className="text-lg font-bold text-cyan-300 mb-4">
        🏦 Subscription & Partner Payment Details
      </h2>

      <div className="grid md:grid-cols-2 gap-3">
        <Row label="Bank Name" value={COMPANY.bankName} />
        <Row label="Branch" value={COMPANY.branch} />
        <Row label="Account Number" value={COMPANY.accountNumber} />
        <Row label="IFSC" value={COMPANY.ifsc} />
        <Row label="SWIFT" value={COMPANY.swift} />
      </div>

      <div
        className="
          mt-4
          rounded-xl
          bg-yellow-950/20
          border border-yellow-500/30
          p-4
        "
      >
        <div className="font-semibold text-yellow-300 mb-1">
          Partner Subscription Purchase
        </div>

        <div className="text-xs text-yellow-100">
          Partner subscriptions are processed through prepaid bank
          transfer. Share transaction details through Email or
          WhatsApp for verification and activation.
        </div>
      </div>
    </div>
  );
}